import { useCallback } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  const handleNavClick = useCallback((anchor: string) => {
    const el = document.getElementById(anchor);
    if (el) {
      const headerHeight = 72;
      const elTop = el.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elTop - headerHeight, behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header onNavClick={handleNavClick} />

      <main>
        <Hero />

        <FaqSection />

        <RankingSection />

        <IndexSection />

        <ContactSection />

        <UpdatesSection />

        <AppSection />

        <CardsSection />

        <AboutSection />

        <CommentsSection />

        <TopicsSection />

        <FeaturesSection />

        <MediaSection />

        <CarouselSection />
      </main>

      <Footer />
    </div>
  );
}